import { h } from 'preact';
import MediaList from 'components/list/mediaList';
import { isVideoFile } from 'utils/assets';

import s from 'components/list/mediaList.sss';

export default class MediaSelectList extends MediaList {
	constructor(props) {
		super(props);
		const group = this.findGroup(props.initialGroup);
		if (group) this.selectGroup(group);
	}

	get itemsSource() {
		let result = super.itemsSource;
		if (this.props.video) {
			result = result.filter(item => isVideoFile(item.name));
		} else if (!this.props.anyType) {
			result = result.filter(item => !isVideoFile(item.name));
		}
		return result;
	}

	getTitle() {
		return 'Select media';
	}
	getDescription() {}
	renderButtons() {}

	updateURL() { /* Nothing */ }
	updateFromURL() { /* Nothing */ }

	selectItem(item) {
		this.base.closest('dialog')?.close(JSON.stringify(item));
	}

	onItemClick(item) {
		return this.selectItem(item);
	}

	renderListItemName(item) {
		if (this.state.groupedMedia && !this.state.activeGroup) {
			return (
				<div class={s.listMediaAssetsGroup}>
					{this.renderAsset(item)}
					<button onClick={() => this.selectGroup(item)}>{item.name}</button>
				</div>
			);
		}
		return (
			<div class={s.nameAsset}>
				{this.renderAsset(item)}
				<button onClick={() => this.onItemClick(item)}>{this.getItemName(item)}</button>
			</div>
		);
	}
}